import { jsx } from 'react/jsx-runtime';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import { E as EGDSLayout } from '../layout/index-chunk.esm.js';
import * as React from 'react';
import { E as EGDSLayoutSpaces, c as EGDSLayoutSizes } from '../types/index-chunk.esm2.js';
import styles from '../styles/uitk-egds-layout-columns.css';
const EGDSLayoutColumnCountMap = [[1, '1'], [2, '2'], [3, '3'], [4, '4'], [5, '5'], [6, '6'], [8, '8'], [12, '12']];
const EGDSLayoutColumnCounts = new Map(EGDSLayoutColumnCountMap);
const EGDSLayoutColumnItemSpanMap = [['all', 'column-span-all']];
const EGDSLayoutColumnItemSpans = new Map(EGDSLayoutColumnItemSpanMap);
const EGDSLayoutColumnItemBreakInsideMap = [['avoid', 'break-inside-avoid']];
const EGDSLayoutColumnItemBreakInsides = new Map(EGDSLayoutColumnItemBreakInsideMap);
const EGDSLayoutColumnItemBreakBeforeMap = [['avoid', 'break-before-avoid']];
const EGDSLayoutColumnItemBreakBefores = new Map(EGDSLayoutColumnItemBreakBeforeMap);
const EGDSLayoutColumnItemBreakAfterMap = [['avoid', 'break-after-avoid']];
const EGDSLayoutColumnItemBreakAfters = new Map(EGDSLayoutColumnItemBreakAfterMap);
const getClassNameList$1 = classNames.bind(styles);
const EGDSLayoutColumns = props => {
  const {
    children,
    className,
    space,
    tag,
    columns,
    minWidth,
    ...attributes
  } = props;
  const baseClass = 'uitk-layout-columns';
  const wrapperClassNames = getClassNameList$1(baseClass, columns && `${baseClass}-${EGDSLayoutColumnCounts.get(columns)}`, space && `${baseClass}-${EGDSLayoutSpaces.get(space)}`, minWidth && `${baseClass}-minwidth-${EGDSLayoutSizes.get(minWidth)}`, className);
  return jsx(EGDSLayout, {
    className: wrapperClassNames,
    tag: tag,
    ...attributes,
    children: children || null
  });
};
const getClassNameList = classNames.bind(styles);
const EGDSLayoutColumnsItem = props => {
  const {
    breakAfter,
    breakBefore,
    breakInside,
    children,
    className,
    columnSpan,
    forceNoBreak,
    style
  } = props;
  const childrenArray = React.Children.toArray(children);
  if (!childrenArray.length) {
    return null;
  }
  const firstChild = childrenArray[0];
  const firstChildClassName = firstChild.props.className;
  const firstChildStyle = firstChild.props.style;
  const baseClass = 'uitk-layout-columns-item';
  const wrapperClassNames = getClassNameList(baseClass, firstChildClassName, breakAfter && `${baseClass}-${EGDSLayoutColumnItemBreakAfters.get(breakAfter)}`, breakBefore && `${baseClass}-${EGDSLayoutColumnItemBreakBefores.get(breakBefore)}`, breakInside && `${baseClass}-${EGDSLayoutColumnItemBreakInsides.get(breakInside)}`, columnSpan && `${baseClass}-${EGDSLayoutColumnItemSpans.get(columnSpan)}`, forceNoBreak && `${baseClass}-force-no-break`, className);
  const wrapperStyle = {
    ...firstChildStyle,
    ...style
  };
  const decoratedChild = React.cloneElement(firstChild, {
    className: wrapperClassNames,
    ...(Object.keys(wrapperStyle).length && {
      style: wrapperStyle
    })
  });
  return decoratedChild;
};
export { EGDSLayoutColumns as E, EGDSLayoutColumnsItem as a };